import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  endAdornment?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({ label, error, icon, endAdornment, className, ...props }) => {
  const inputClasses = `w-full rounded-lg border border-[rgb(var(--border))] bg-[rgb(var(--background))] px-4 py-3 text-[rgb(var(--foreground))] placeholder:text-[rgb(var(--light-secondary))] focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-colors ${icon ? 'pl-10' : ''} ${endAdornment ? 'pr-10' : ''} ${error ? 'border-red-500' : ''} ${className}`;
  return (
    <div className="space-y-1">
      {label && <label className="text-sm font-medium text-[rgb(var(--foreground))]">{label}</label>}
      <div className="relative">
        {icon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2">{icon}</span>
        )}
        <input className={inputClasses} {...props} />
        {endAdornment && <span className="absolute right-3 top-1/2 -translate-y-1/2">{endAdornment}</span>}
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};